import React from "react";
import { Helmet } from "react-helmet-async";

import Hero from "../components/Hero";
import "../pages/Home.css";

import ServiceShowcase from "../components/ServiceShowcase";
import WhyChoose from "../components/WhyChoose";
import Services from "../components/Services";

import About from "../components/About";
import Brands from "../components/Brands";
import Faqs from "../components/Faqs";

const Home = () => {
  return (
    <>
 <Helmet>
  <title>Appliance Repair Services in Bangalore | Customersupports24x7</title>

  <meta
    name="description"
    content="Expert appliance repair services in Bangalore for all major brands. Fast doorstep service by skilled technicians."
  />

  <meta
    name="keywords"
    content="appliance repair bangalore, mobile repair bangalore, doorstep repair service"
  />

  <meta
    name="robots"
    content="index, follow"
  />

  <meta
    name="author"
    content="Customer Supports 24x7"
  />

  <meta
    name="publisher"
    content="Customer Supports 24x7"
  />

  <meta
    property="og:title"
    content="Appliance Repair Services in Bangalore | Customersupports24x7"
  />
  <meta
    property="og:description"
    content="Expert appliance repair services in Bangalore for all major brands. Fast doorstep service by skilled technicians."
  />
  <meta
    property="og:image"
    content="https://customersupports24x7.in/customerSupport.png"
  />
  <meta
    property="og:url"
    content="https://customersupports24x7.in/"
  />
  <meta
    property="og:type"
    content="website"
  />

  <meta
    name="twitter:card"
    content="summary_large_image"
  />
  <meta
    name="twitter:title"
    content="Appliance Repair Services in Bangalore | Customersupports24x7"
  />
  <meta
    name="twitter:description"
    content="Expert appliance repair services in Bangalore for all major brands. Fast doorstep service by skilled technicians."
  />
  <meta
    name="twitter:image"
    content="https://customersupports24x7.in/customerSupport.png"
  />

  <link
    rel="canonical"
    href="https://customersupports24x7.in/"
  />
</Helmet>
      <main className="home-page">
        <Hero />
        <About />
        <Services />
        <Brands />
        <WhyChoose />
        <ServiceShowcase />
        <Faqs />
      </main>
    </>
  );
};

export default Home;
